module.exports = __webpack_public_path__ + "static/img/brees-2012-slide-6.c7a85a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-slide-6.jpg
// module id = 7D4f
// module chunks = 1